import { render, staticRenderFns } from "./FundsList.vue?vue&type=template&id=cc80ec0e&scoped=true&"
import script from "./FundsList.vue?vue&type=script&lang=js&"
export * from "./FundsList.vue?vue&type=script&lang=js&"
import style0 from "./FundsList.vue?vue&type=style&index=0&id=cc80ec0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc80ec0e",
  null
  
)

export default component.exports